export default "__VITE_ASSET__2VLgQa8v__"